import { Button, Icon, IconName, IconSize, Link, Text, TextLevels, VariantState } from '@bytel/trilogy-react-ts';
import { emptyGuid } from '@shared/constants';
import UrlToken from '@shared/misc/helpers/urlToken';
import React from 'react';
import { Link as routerLink } from 'react-router-dom';
import { HeadbandCreationProps } from './type';

const HeadbandCreation: React.FC<HeadbandCreationProps> = ({ dataCy, PATH, t, urlCreate, id }) => {
  return (
    <Link
      fixed
      to={PATH.replace(id, UrlToken.fromXLink({ href: emptyGuid }).toString())}
      data-cy={`${dataCy}-new-button`}
      routerLink={routerLink}
      className="is-flex is-justified-end is-plain"
    >
      <Button disabled={urlCreate === undefined} variant={VariantState.TERTIARY} className="is-fullwidth">
        <Icon name={IconName.PLUS} size={IconSize.SMALL} align="ALIGNED_CENTER" />
        <Text level={TextLevels.ONE} className="has-text-white">
          {t('new.button')}
        </Text>
      </Button>
    </Link>
  );
};

export default HeadbandCreation;
